// services/containerApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getContainers = async (params) => {
  return await api.get('/containers', { params });
};

export const getContainer = async (id) => {
  return await api.get(`/containers/${id}`);
};

export const createContainer = async (data) => {
  return await api.post('/containers', data);
};

export const updateContainer = async (id, data) => {
  return await api.put(`/containers/${id}`, data);
};

export const deleteContainer = async (id) => {
  return await api.delete(`/containers/${id}`);
};